import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { loadSalesUserAuthData, loadUserAuthData } from '../../../action/auth_action';
import { isAuthenticated, getUserData , getLocalData  } from '../../../util/util';

export const AuthGuardImpl = ({ component: Template, ...rest }) => {
  loadUserAuthData();

  //Authenticate Sales User
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

AuthGuardImpl.defaultProps = {
  location: {}
};

AuthGuardImpl.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};

export const PublicRoute = ({ component: Template, ...rest }) => {

  const userInfo = getUserData();
  let redirectUrl = '';
  if (userInfo) {
      redirectUrl = '/payment';  
  }
  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated() ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectUrl,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

PublicRoute.defaultProps = {
  location: {}
};

PublicRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};

export const AuthSalesUser = ({ component: Template, ...rest }) => {

  loadSalesUserAuthData();
  const salesUserInfo = getLocalData('salesUserInfo');
  return (
    <Route
      {...rest}
      render={props =>
        salesUserInfo ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/tp/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};
AuthSalesUser.defaultProps = {
  location: {}
};

AuthSalesUser.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};




// WEBPACK FOOTER //
// ./web/components/salesUser/common/AuthGuard.jsx